import React, { useMemo, useState } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  AlertComponent,
  SearchInputComponent,
} from "../../../common/components";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import { LeadFilterProps } from "./lead-capture-filter.props";
import "./lead-capture-filter.scss";
import { useNavigate } from "react-router-dom";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
import { useSetLoading } from "../../../common/hooks/appearance";
import Button from "../../../common/components/button/button";
import RefreshIcon from '@mui/icons-material/Refresh';

const LeadCaptureFilter: React.FC<LeadFilterProps> = (props: any) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedLeadsFilter,
    selectedCreateLeads,
    setSelectedCreateLeads,
    onSearch,
    searchRef,
    resetSearch,
    isResetSearch,
    handleClickCreateNewForm,
    fetchData,
    // disabled,
    // setIsShowCreateLead,
    // isShowCreateLead,
    // setShowImportModal,
    // isShowCreateLeadSection, 
    // setIsShowCreateLeadSection,
  } = props;
  console.log('selected',selectedLeadsFilter)
  const navigate = useNavigate();
  const { canRead, canWrite, canDelete } = useResourcePermissions(
    MODULES.LEAD_CAPTURE
  );

  
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  // const handleCreateLeadAction = (option: { value: string; id: number }) => {
  //   setSelectedCreateLeads(option.value);
  //   if (option.value === "Import Leads") {
  //     setShowImportModal(true);
  //   } else if (option.value === "Social Media Import") {
  //     navigate(routes.SOCIALIMPORTLEAD);
  //   }
  // };

  const handleRefresh = () => {
     fetchData?.()
  };

  return (
    <div className="lead-capture-search-filter-wrapper">
      <div className="lead-capture-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Form Name,Created By"
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="lead-capture-filter-wrapper">
        <div className="lead-capture-refresh-icon" onClick={handleRefresh} tabIndex={0} title="Refresh">
          <RefreshIcon sx={{ color: "action.active" }}/>
        </div>
        <div
          className="lead-capture-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge color="secondary" sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#887952',
              },
            }} badgeContent={selectedLeadsFilter}>
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
        {canWrite && (
          <div className="lead-capture-create-filter">
            <Button
            label="Create New Form"
            onClick={handleClickCreateNewForm}
            />
          </div>
        )}
      </div>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default LeadCaptureFilter;
